import React from 'react';
// import { Button } from '@/components/ui/button'; // Não mais necessário para o X aqui
// import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'; // Card não é mais o container principal
// import { X } from 'lucide-react'; // O Dialog do Shadcn geralmente tem seu próprio X

// onClose não é mais necessário aqui, o Dialog controlará o fechamento.
// interface GamificationConfigHelpProps {
//   onClose?: () => void;
// }

const GamificationConfigHelp: React.FC = () => {
  return (
    <div className="prose prose-sm max-w-none dark:prose-invert overflow-y-auto max-h-[70vh] p-1 md:p-2">
      {/* O Dialog.Title será usado externamente, então o CardTitle/Description aqui não são mais centrais */}
      {/* Poderíamos ter um h2 aqui se quiséssemos um título interno ao conteúdo scrollável */}
      {/* <h2 className="text-xl font-semibold mb-3">Referência de Configuração JSON</h2> */}
      {/* <p className="text-sm text-muted-foreground mb-4">Guia para configurar os campos JSON de Missões, Badges e Eventos Especiais.</p> */}
      
      <p className="mt-0">
        Este guia detalha a estrutura e os exemplos para os campos JSON utilizados
        nos formulários de administração do sistema de gamificação.
      </p>

      {/* Seção de Missões */}
      <section id="missions-config">
        <h3 className="text-lg font-semibold mt-4 mb-2">1. Missões (`required_actions`)</h3>
        <p>
          O campo <code>required_actions</code> na tabela <code>missions</code> é um JSON array que define
          as ações que um usuário precisa completar para concluir a missão. Cada objeto no
          array representa um requisito de ação.
        </p>
        <h4 className="text-md font-semibold mt-3 mb-1">Estrutura de um Requisito de Ação:</h4>
        <pre className="bg-gray-100 dark:bg-gray-800 p-3 rounded-md overflow-x-auto text-xs">
          <code>
{`{
  "action_type": "string",
  "quantity": "integer",
  "params": {
    "key": "value"
  }
}`}
          </code>
        </pre>
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li>
            <strong><code>action_type</code> (Obrigatório):</strong> Uma string que identifica a ação a ser rastreada.
            Geralmente corresponde a uma <code>XpActionKey</code> (ex: <code>create_post</code>, <code>rate_game</code>) ou
            chaves de ação personalizadas.
          </li>
          <li>
            <strong><code>quantity</code> (Obrigatório):</strong> Um número inteiro que define quantas vezes a{" "}
            <code>action_type</code> deve ser realizada.
          </li>
          <li>
            <strong><code>params</code> (Opcional):</strong> Um objeto JSON com parâmetros adicionais.
            <ul className="list-circle pl-5 space-y-0.5 mt-1">
              <li><code>unique_entity: boolean</code>: Se <code>true</code>, cada instância da ação deve ser em uma entidade diferente.</li>
              <li><code>category: string</code>: Se especificado, a ação só conta se a entidade relacionada pertencer a esta categoria.</li>
            </ul>
          </li>
        </ul>
        <h4 className="text-md font-semibold mt-3 mb-1">Exemplo: Missão "Engajador Social"</h4>
        <pre className="bg-gray-100 dark:bg-gray-800 p-3 rounded-md overflow-x-auto text-xs">
          <code>
{`[
  {
    "action_type": "like_post",
    "quantity": 5,
    "params": {
      "unique_entity": true
    }
  },
  {
    "action_type": "comment_post",
    "quantity": 2,
    "params": {
      "unique_entity": true
    }
  }
]`}
          </code>
        </pre>
      </section>

      {/* Seção de Badges */}
      <section id="badges-config" className="mt-6">
        <h3 className="text-lg font-semibold mt-4 mb-2">2. Badges (`criteria_data`)</h3>
        <p>
          O campo <code>criteria_data</code> na tabela <code>badges</code> é um JSON objeto cuja estrutura
          depende do valor do campo <code>criteria_type</code>.
        </p>
        {/* Conteúdo completo de Badges virá aqui */}
      </section>

      {/* Seção de Eventos */}
      <section id="events-config" className="mt-6">
        <h3 className="text-lg font-semibold mt-4 mb-2">3. Eventos Especiais (`config`)</h3>
        <p>
          O campo <code>config</code> na tabela <code>special_events</code> é um JSON objeto cuja estrutura
          depende do valor do campo <code>event_type</code>.
        </p>
        {/* Conteúdo completo de Eventos virá aqui */}
      </section>

    </div>
  );
};

export default GamificationConfigHelp; 